export class TableColumnFilter {
  constructor(
    public visible: boolean,
    public value: string,
  ) {}
}
